




























































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  GetExportResultsList,
  CheckTable,
  ExportTable,
  DeleteTable,
} from "@/request/tongue";
import { GetDataTables } from "@/request/data-filter";
import Pagination from "@/components/paginaiton.vue";
import PreviewDialog from "./previewDialog.vue";
@Component({
  components: {
    Pagination,
    PreviewDialog,
  },
})
export default class TongueExportResults extends Vue {
  private messages: any[] = [];
  private currentPage: any = 1;
  private totalCount: any = 0;
  private pageCount: any = 10;
  private totalPage: any = 0;
  private filters: any = {
    search: "",
  };
  private ifShowPreview: boolean = false;
  private tempTableId: any = "";
  /**
   * @description 获取列表
   */
  private fetchList() {
    const loading = this.$loading({ text: "加载中..." });
    const params: any = {
      params: {
        current_page: this.currentPage,
        page_count: this.pageCount,
        sort_field: "创建时间",
        sort_value: 0,
        search: this.filters.search,
      },
    };
    GetDataTables(this, params)
      .then((data: any) => {
        this.messages = data.tables;
        this.totalCount = data.total_count;
        this.totalPage = data.total_page;
      })
      .finally(() => {
        loading.close();
      });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.currentPage = 1;
    this.fetchList();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.fetchList();
  }
  /**
   * @description 查看
   */
  private checkOne(table) {
    this.tempTableId = table.table_id;
    this.ifShowPreview = true;
  }
  /**
   * @description 导出
   */
  private exportOne(table) {
    const loading = this.$loading({
      lock: true,
      text: "导出中",
      spinner: "el-icon-loading",
    });
    const params: any = {
      table_id: table.table_id,
    };
    ExportTable(this, params).then((data: any) => {
      loading.close();
      window.open(
        window.API_ROOT + "api/wajue/download?filename=" + data.file_name
      );
    });
  }
  /**
   * @description 删除
   */
  private deleteOne(table) {
    this.$confirm("确定要删除吗？").then(() => {
      const params: any = {
        data: {
          table_id: table.table_id,
        },
      };
      DeleteTable(this, params).then((data: any) => {
        this.$message.success("删除成功");
        this.fetchList();
      });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.search();
  }
}
